import { withFormsy, propTypes } from 'formsy-react';
import React, { PureComponent } from 'react';
import Async from 'react-select/async';
import { components } from 'react-select';
import { Row, Col } from 'reactstrap';
import qs from 'qs';
import axios from 'axios';
import PropTypes from 'prop-types';
import _ from 'lodash';
import getAxiosInstance from 'app/config/api';
import domainModel from 'domain-model';

let cancelTokenSource = null;

/* eslint-disable */
const MenuList = props => {
  return (
    <components.MenuList {...props}>
      <table class="table w-100 mt-n1">
        <caption>
          Lista med sökresultat,{' '}
          {props.options.length === 0
            ? 'sökningen gav inget resultat'
            : 'skriv för att söka efter fler.'}
        </caption>
        <thead class="table-light">
          <tr>
            <th className="text-nowrap text-center w-100 py-1">Artikelnamn</th>

            <th className="text-nowrap text-center w-100 py-1">
              Alkohol procent
            </th>

            <th className="text-nowrap text-center w-100 py-1">
              Försäljningspris per styck på webben (exkl. pant)
            </th>

            <th className="text-nowrap text-center w-100 py-1">
              Kategori / Typ / Stil
            </th>
            <th className="text-nowrap text-center w-100 py-1">
              Artikelnummer
            </th>
          </tr>
        </thead>
        <tbody>{props.children}</tbody>
      </table>
    </components.MenuList>
  );
};

const Option = props => {
  return (
    <tr
      id={props.innerProps.id}
      ref={props.innerRef}
      className={
        (props.isSelected ? 'table-active' : '') +
        (props.isFocused ? ' bg-light' : '') +
        ' select-option'
      }
      onClick={() => {
        props.selectOption(props.data);
      }}
    >
      <td className="text-nowrap py-1">{props.data.shortName}</td>
      <td className="text-nowrap py-1">{props.data.alcoholPercentage}</td>
      <td className="text-nowrap py-1">{props.data.salesPrice}</td>
      <td className="text-nowrap py-1">{props.data.productCategory}</td>
      <td className="text-nowrap py-1">{props.data.articleNumber}</td>
    </tr>
  );
};

function withFormsyValidations(
  WrappedComponent,
  validations,
  validationErrors,
) {
  const FormsyfiedComponent = withFormsy(WrappedComponent);

  return props => (
    <FormsyfiedComponent
      validations={validations ? validations(props) : undefined}
      validationErrors={validationErrors}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      value={_.get(props, 'value.id')}
      article={props.value}
    />
  );
}

const ValueContainer = ({ children, selectProps, ...restOfProps }) => {
  const pricedArticle = selectProps.value || {};
  const {
    disposableQuantity = 0,
    quantityInStock = 0,
    colliSize = 1,
    image = 'https://assets.flaivy.com/100x100/623315650968a814f1d5739fe2548da4.png',
  } = pricedArticle;

  return (
    <>
      <Row style={{ width: '95%' }} className="justify-content-between">
        <Col sm={3} xs={12} className="align-self-center text-center">
          <img
            style={{ width: '100px', minWidth: '100px' }}
            className="m-2"
            src={image}
          />
        </Col>
        <Col sm={9} xs={12} className="ps-sm-4 ms-sm-0 ms-2">
          <Row>
            <Col className="mt-sm-2">
              <h5>
                <components.ValueContainer
                  {...{ ...restOfProps, selectProps }}
                  className="ps-0"
                >
                  {children}
                </components.ValueContainer>
              </h5>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
/* eslint-enable */

class ArticleSelect extends PureComponent {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      isDisabled: PropTypes.bool,
      onChange: PropTypes.func,
      customerSubUnit: PropTypes.object,
      ...propTypes,
    };
  }

  static get defaultProps() {
    return {
      isDisabled: false,
      customerSubUnit: undefined,
      onChange: () => {},
    };
  }

  constructor(props) {
    super(props);
    this.search = this.search.bind(this);
    this.selectHandler = this.selectHandler.bind(this);
  }

  async search(inputValue) {
    const { customerSubUnit } = this.props;
    const query = {
      active: true,
      ...domainModel.article.createSearchStringQuery(inputValue),
    };

    const queryStr = qs.stringify({
      query,
      customerSubUnit: _.get(customerSubUnit, 'id'),
      cacheBuster: new Date().getTime(),
    });
    const requestUrl = `/public/articles/?${queryStr}`;
    if (cancelTokenSource) {
      cancelTokenSource.cancel();
    }
    cancelTokenSource = axios.CancelToken.source();
    const response = await getAxiosInstance().get(`${requestUrl}`, {
      cancelToken: cancelTokenSource.token,
    });

    cancelTokenSource = null;
    return response.data.rows;
  }

  async selectHandler(selectedArticle) {
    const { setValue } = this.props;
    const { onChange, name, customerSubUnit } = this.props;
    const queryStr = qs.stringify({
      customerSubUnit: _.get(customerSubUnit, 'id'),
    });
    const requestUrl = `/public/articles/${selectedArticle.id}?${queryStr}`;
    const response = await getAxiosInstance().get(requestUrl);
    const article = response.data;
    setValue(article.id);
    onChange(name, article);
  }

  render() {
    const { name, article, isDisabled, isValid } = this.props;
    return (
      <Async
        id={_.uniqueId('article-select')}
        cacheOptions
        instanceId={`select-${name}`}
        noOptionsMessage={() => ''}
        openMenuOnClick={false}
        className={!isValid ? 'border border-danger' : ''}
        name={name.id}
        value={article}
        components={{ ValueContainer, MenuList, Option }}
        isDisabled={isDisabled}
        loadOptions={this.search}
        placeholder="Sök ..."
        getOptionValue={option => option.id}
        getOptionLabel={option => `${option.shortName}`}
        onChange={this.selectHandler}
        styles={{
          // Fixes the overlapping problem of the component
          menu: provided => ({
            ...provided,
            zIndex: 9999,
            position: 'relative',
          }),
        }}
      />
    );
  }
}

export default withFormsyValidations(ArticleSelect, props => ({
  requiredValidation(values, value) {
    if (props.required) {
      return !!value;
    }
    return true;
  },
}));
